<template>
  <div class="kpg">

    <!-- ═══ Tabs ═══ -->
    <div class="kpg__tabs-bar">
      <div class="kpg__tabs">
        <button class="kpg__tab" :class="{ 'kpg__tab--active': activeTab === 0 }" @click="activeTab = 0">
          <i class="fa-solid fa-receipt"></i> Gastos
        </button>
        <button class="kpg__tab" :class="{ 'kpg__tab--active': activeTab === 1 }" @click="activeTab = 1">
          <i class="fa-solid fa-building-columns"></i> Movimientos Banco
        </button>
        <button class="kpg__tab" :class="{ 'kpg__tab--active': activeTab === 2 }" @click="activeTab = 2">
          <i class="fa-solid fa-gears"></i> Reglas
        </button>
      </div>
      <button class="kpg__btn-icon" @click="$router.push('/kpi');" v-b-tooltip.hover title="Volver a KPI">
        <i class="fa-solid fa-arrow-left"></i>
      </button>
    </div>

    <b-tabs v-model="activeTab" content-class="mt-1" class="kpg__tabs-hidden">
      <b-tab>
        <div class="kpg__section-header" style="margin-bottom: 14px;">
          <i class="fa-solid fa-plus kpg__section-icon kpg__section-icon--success"></i>
          <span class="kpg__section-title">Nuevo Gasto</span>
          <span v-if="movimientoSeleccionado.id != 0" class="kpg__section-subtitle">
            | {{ movimientoSeleccionado.descripcion }}
            <button class="kpg__btn-icon-sm" @click="resetWizard()" v-b-tooltip.hover title="Limpiar">
              <i class="fa-solid fa-eraser"></i>
            </button>
          </span>
        </div>
        <form-wizard color="#7367F0" :title="null" :subtitle="null" layout="vertical" finish-button-text="Guardar"
          back-button-text="Atras" class="wizard-vertical mb-3 wizard-harber" ref="wizardPago">
          <template v-slot:footer="props">
            <div class="wizard-footer-left">
              <b-button v-if="props.activeTabIndex > 0" :style="props.fillButtonStyle" @click="atrasPaso(props)"
                class="wizard-button">
                Atras
              </b-button>
            </div>
            <div class="wizard-footer-right">
              <b-button v-if="!props.isLastStep" @click="siguientePaso(props)" class="wizard-button"
                :style="props.fillButtonStyle" id="next-button">
                Continuar
              </b-button>

              <b-button v-else @click="formSubmitted()" class="finish-button" style="background-color: #3bab76 !important;
          border-color: #3bab76 !important;">
                Guardar
              </b-button>
            </div>
          </template>
          <!-- account datails tab -->
          <tab-content title="Tipo">
            <b-row>
              <!--<b-col cols="12" class="mb-2">
            <h5 class="mb-0">Tipo de gasto</h5>
          </b-col>-->
              <b-col md="4">
                <b-card :class="{ 'border-puntual': tipoGasto === 'puntual' }"
                  class="mb-2 text-center card-click gasto-puntual" @click="tipoGasto = 'puntual'" title="Puntual">

                  <span class="circle-indicator gasto-puntual"></span>


                  <b-card-text style="text-align: center;">
                    Un unico pago en una fecha específica que no se va a repetir, solo afectara a un dia.
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="puntual" :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>
                </b-card>
              </b-col>
              <!--<b-col md="4">
            <b-card
              :class="{'border-mensual': tipoGasto === 'mensual'}"
              class="mb-2 text-center card-click gasto-mensual"
              @click="tipoGasto = 'mensual'"
              title="Mensual"
            >

                <span class="circle-indicator gasto-mensual"></span>

                <b-card-text style="text-align: center;">
                  Un gasto que se repite cada mes, se prorrateara el gasto diariamente.
                </b-card-text>

                <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                  <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="mensual"  :class="`radio-${tipoGasto}`"  ></b-form-radio>
                </b-form-group>
            </b-card>
          </b-col>-->
              <b-col md="4">
                <b-card :class="{ 'border-anual': tipoGasto === 'anual' }" class="mb-2 text-center card-click gasto-anual"
                  @click="tipoGasto = 'anual'" title="Anual">

                  <span class="circle-indicator gasto-anual"></span>
                  <b-card-text style="text-align: center;">
                    Un unico pago anual en una fecha específica, se prorrateara el gasto diariamente.
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="anual" :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>

                </b-card>
              </b-col>
              <b-col md="4">
                <b-card :class="{ 'border-nomina': tipoGasto === 'nomina' }"
                  class="mb-2 text-center card-click gasto-nomina" @click="tipoGasto = 'nomina'" title="Nomina">
                  <span class="circle-indicator gasto-nomina"></span>
                  <b-card-text style="text-align: center;">
                    Pondremos el precio de las nominas correspondientes de un mes. (el precio se prorrateara diariamente
                    al mes
                    siguiente)
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="nomina" :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col md="4">
                <b-card :class="{ 'border-impuestos': tipoGasto === 'impuestos' }"
                  class="mb-2 text-center card-click gasto-impuestos" @click="tipoGasto = 'impuestos'"
                  title="Impuestos">
                  <span class="circle-indicator gasto-impuestos"></span>
                  <b-card-text style="text-align: center;">
                    Gasto que se va a prorratear diariamente durante un tramo de tiempo.
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="impuestos" :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col md="4">
                <b-card :class="{ 'border-ads': tipoGasto === 'ads' }" class="mb-2 text-center card-click gasto-ads"
                  @click="tipoGasto = 'ads'" title="Ads">
                  <span class="circle-indicator gasto-ads"></span>
                  <b-card-text style="text-align: center;">
                    Gasto que se va a prorratear diariamente durante el mes seleccionado.
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios" value="ads"
                      :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>
                </b-card>
              </b-col>
              <b-col md="4">
                <b-card :class="{ 'border-envios': tipoGasto === 'envios' }"
                  class="mb-2 text-center card-click gasto-envios" @click="tipoGasto = 'envios'" title="Envios">
                  <span class="circle-indicator gasto-envios"></span>
                  <b-card-text style="text-align: center;">
                    Un unico pago en una fecha específica que no se va a repetir, solo afectara a un dia.
                  </b-card-text>

                  <b-form-group v-slot="{ ariaDescribedby }" class="d-flex justify-content-center">
                    <b-form-radio v-model="tipoGasto" :aria-describedby="ariaDescribedby" name="some-radios"
                      value="envios" :class="`radio-${tipoGasto}`"></b-form-radio>
                  </b-form-group>
                </b-card>
              </b-col>
            </b-row>
          </tab-content>

          <!-- personal info tab -->
          <tab-content title="Información">
            <b-row v-if="tipoGasto !== 'nomina' && tipoGasto !== 'impuestos' && tipoGasto !== 'ads'">
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">Información</h5>
                <!--<small class="text-muted">Enter Your Personal Info.</small>-->
              </b-col>
              <b-col md="3">
                <b-form-group label="Nombre*" label-for="v-first-name">
                  <b-form-input id="v-first-name" placeholder="" v-model="nombre" />
                </b-form-group>
              </b-col>
              <b-col md="3">
                <b-form-group label="Descripcion" label-for="v-last-name">
                  <b-form-input id="v-last-name" placeholder="" v-model="descripcion" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Empresa*" label-for="v-country">
                  <v-select id="v-country" v-model="empresaSeleccionada" :options="empresas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Categoria*" label-for="v-country">
                  <v-select id="v-country" v-model="categoriaSeleccionada" :options="categorias" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Importancia" label-for="v-country">
                  <v-select id="v-country" v-model="importanciaSeleccionada" :options="importanciaOpciones"
                    label="text" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="tipoGasto === 'nomina'">
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">Información {{ tipoGasto }}</h5>
                <!--<small class="text-muted">Enter Your Personal Info.</small>-->
              </b-col>
              <b-col md="4">
                <b-form-group label="Nombre" label-for="v-last-name">
                  <b-form-input id="v-last-name" placeholder="" v-model="nombre" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Empresa*" label-for="v-country">
                  <v-select id="v-country" v-model="empresaSeleccionada" :options="empresas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Moneda*" label-for="v-moneda">
                  <v-select id="v-moneda" v-model="monedaSeleccionada" :options="monedas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Precio*" label-for="v-precio">
                  <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio" v-model="precio"
                    @wheel.prevent />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Fecha*" label-for="v-fecha">
                  <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha" v-model="fecha" />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="tipoGasto === 'impuestos'">
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">Información {{ tipoGasto }}</h5>
                <!--<small class="text-muted">Enter Your Personal Info.</small>-->
              </b-col>
              <b-col md="4">
                <b-form-group label="Nombre" label-for="v-last-name">
                  <b-form-input id="v-last-name" placeholder="" v-model="nombre" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Empresa*" label-for="v-country">
                  <v-select id="v-country" v-model="empresaSeleccionada" :options="empresas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Moneda*" label-for="v-moneda">
                  <v-select id="v-moneda" v-model="monedaSeleccionada" :options="monedas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Precio*" label-for="v-precio">
                  <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio" v-model="precio"
                    @wheel.prevent />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Fecha*" label-for="v-fecha">
                  <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha" v-model="fecha" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
                  <b-form-select v-model="tipoAnualCobro" :options="optionsAnualCobroImpuestos"
                    class="mb-2"></b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row v-if="tipoGasto === 'ads'">
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">Información {{ tipoGasto }}</h5>
                <!--<small class="text-muted">Enter Your Personal Info.</small>-->
              </b-col>
              <b-col md="4">
                <b-form-group label="Nombre" label-for="v-last-name">
                  <b-form-input id="v-last-name" placeholder="" v-model="nombre" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Moneda*" label-for="v-moneda">
                  <v-select id="v-moneda" v-model="monedaSeleccionada" :options="monedas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="Precio*" label-for="v-precio">
                  <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio" v-model="precio"
                    @wheel.prevent />
                </b-form-group>
              </b-col>
              <b-col md="2">
                <b-form-group label="IVA %" label-for="v-iva">
                  <b-form-input id="v-iva" type="number" placeholder="Ingrese el % de IVA" v-model="iva"
                    @wheel.prevent />
                </b-form-group>
              </b-col>

              <b-col md="2">
                <b-form-group label="Fecha*" label-for="v-fecha">
                  <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha" v-model="fecha" />
                </b-form-group>
              </b-col>
            </b-row>
          </tab-content>

          <!-- Coste -->
          <tab-content title="Coste">
            <b-row>
              <b-col cols="12" class="mb-2">
                <h5 class="mb-0">Coste</h5>
                <small class="text-muted">Introduce toda la informacion del coste del gasto.</small>
              </b-col>
              <b-col md="4">
                <b-form-group label="Moneda*" label-for="v-moneda">
                  <v-select id="v-moneda" v-model="monedaSeleccionada" :options="monedas" label="text" />
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group label="Precio*" label-for="v-precio">
                  <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio" v-model="precio"
                    @wheel.prevent />
                </b-form-group>
              </b-col>

              <b-col md="4">
                <b-form-group label="IVA %" label-for="v-iva">
                  <b-form-input id="v-iva" type="number" placeholder="Ingrese el % de IVA" v-model="iva"
                    @wheel.prevent />
                </b-form-group>
              </b-col>

              <b-col md="4" v-if="tipoGasto === 'puntual' || tipoGasto === 'anual'">
                <b-form-group label="Fecha*" label-for="v-fecha">
                  <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha" v-model="fecha" />
                </b-form-group>
              </b-col>
              <b-col md="2" v-else> </b-col>

              <b-col md="4" v-if="tipoGasto === 'anual'">
                <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
                  <b-form-select v-model="tipoAnualCobro" :options="optionsAnualCobro" class="mb-2"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="4" v-if="false">
                <b-form-group label="Fecha de Inicio*" label-for="v-fecha-inicio">
                  <b-form-input id="v-fecha-inicio" type="date" placeholder="Ingrese la fecha de inicio"
                    v-model="fechaInicio" />
                </b-form-group>
              </b-col>

              <b-col md="4" v-if="false">
                <b-form-group label="Fecha de Fin*" label-for="v-fecha-fin">
                  <b-form-input id="v-fecha-fin" type="date" placeholder="Ingrese la fecha de fin" v-model="fechaFin" />
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="tipoGasto === 'mensual'">
                <b-form-group label="Mes de Inicio*" label-for="v-fecha-mes-inicio">
                  <b-form-select v-model="mesInicioSeleccionado" :options="meses" class="mb-2"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="tipoGasto === 'mensual'">
                <b-form-group label="Año de Inicio*" label-for="v-fecha-ano-inicio">
                  <b-form-select v-model="anioInicioSeleccionado" :options="anios"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="tipoGasto === 'mensual'">
                <b-form-group label="Mes de Fin (incluido)" label-for="v-fecha-mes-fin">
                  <b-form-select v-model="mesFinSeleccionado" :options="meses" class="mb-2"></b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="2" v-if="tipoGasto === 'mensual'">
                <b-form-group label="Año de Fin (incluido)" label-for="v-fecha-ano-fin">
                  <b-form-select v-model="anioFinSeleccionado" :options="anios"></b-form-select>
                </b-form-group>
              </b-col>



            </b-row>
          </tab-content>

          <!-- social link -->
          <tab-content title="Resumen">
            <b-row>
              <b-col md="6" class="mx-auto">
                <b-row>
                  <b-col md="6">
                    <b-card-text>
                      <strong>Tipo de Gasto:</strong> {{ tipoGasto }}
                    </b-card-text>
                    <b-card-text>
                      <strong>Nombre:</strong> {{ nombre }}
                    </b-card-text>
                    <b-card-text>
                      <strong>Descripción:</strong> {{ descripcion }}
                    </b-card-text>
                    <b-card-text>
                      <strong>Empresa:</strong> {{ empresaSeleccionada.text }}
                    </b-card-text>
                    <b-card-text>
                      <strong>Categoría:</strong> {{ categoriaSeleccionada.text }}
                    </b-card-text>
                  </b-col>
                  <b-col md="6">
                    <b-card-text>
                      <strong>Moneda:</strong> {{ monedaSeleccionada.text }}
                    </b-card-text>
                    <b-card-text>
                      <strong>Precio:</strong> {{ precio }}
                    </b-card-text>
                    <b-card-text>
                      <strong>IVA:</strong> {{ iva }}%
                    </b-card-text>
                    <b-card-text
                      v-if="tipoGasto === 'puntual' || tipoGasto === 'anual' || tipoGasto === 'impuestos' || tipoGasto === 'ads' || tipoGasto === 'nomina'">
                      <strong>Fecha:</strong> {{ fecha }}
                    </b-card-text>
                    <b-card-text v-if="tipoGasto === 'anual' || tipoGasto === 'impuestos'">
                      <strong>Tipo de Cobro:</strong> {{ tipoAnualCobro }}
                    </b-card-text>
                    <b-card-text v-if="tipoGasto === 'mensual'">
                      <strong>Fecha de Inicio:</strong> {{ mesInicioSeleccionado }}/{{ anioInicioSeleccionado }}
                    </b-card-text>
                    <b-card-text v-if="tipoGasto === 'mensual'">
                      <strong>Fecha de Fin:</strong> {{ mesFinSeleccionado }}/{{ anioFinSeleccionado }}
                    </b-card-text>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </tab-content>
        </form-wizard>


        <!-- ═══ Listado de gastos ═══ -->
        <div class="kpg__list-section">
          <div class="kpg__section-header">
            <i class="fa-solid fa-list kpg__section-icon kpg__section-icon--primary"></i>
            <span class="kpg__section-title">Listado de gastos</span>
          </div>

          <div class="kpg__filters">
            <div class="kpg__filter-item">
              <label class="kpg__filter-label">Buscar</label>
              <b-form-input type="text" placeholder="Buscar..." v-model="filtroTexto" />
            </div>
            <div class="kpg__filter-item">
              <label class="kpg__filter-label">Tipo</label>
              <v-select v-model="filtroTipo" :options="tipos" label="text" />
            </div>
            <div class="kpg__filter-item">
              <label class="kpg__filter-label">Empresa</label>
              <v-select v-model="filtroEmpresa" :options="empresas" label="text" />
            </div>
            <div class="kpg__filter-item kpg__filter-item--wide">
              <label class="kpg__filter-label">Categoria</label>
              <v-select v-model="filtroCategorias" :options="categorias" label="text" />
            </div>
            <div class="kpg__filter-item">
              <label class="kpg__filter-label">Importancia</label>
              <v-select v-model="filtroImportancia" :options="importanciaOpciones" label="text" />
            </div>
          </div>

          <div class="kpg__table-card">
            <div class="kpg__tabla-scroll">
              <b-table :items="formartedItems" :fields="columnasTable" :tbody-tr-class="rowClass"
                class="kpg__table" no-border-collapse sort-icon-left ref="tablePagos" hover>

                <template #cell(options)="data">
                  <div class="kpg__actions">
                    <span class="kpg__action kpg__action--delete" @click="deletePago(data.item)" v-b-tooltip.hover.v-danger title="Eliminar">
                      <i class="fa-solid fa-trash"></i>
                    </span>
                  </div>
                </template>

                <template #cell(_edit)="data">
                  <div class="kpg__actions">
                    <span class="kpg__action kpg__action--edit" @click="editPago(data.item)" v-b-tooltip.hover title="Editar">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </span>
                  </div>
                </template>

                <template #cell(_fechaFin)="data">
                  <span v-if="data.item.tipoGasto == 'mensual'">{{ data.item.fechaFin }}
                    <span class="kpg__action kpg__action--edit" style="display: inline-flex;" @click="editarFechaPagado(data.item)">
                      <i class="fa-solid fa-pen-to-square"></i>
                    </span>
                  </span>
                </template>

                <template #cell(_fechaInicio)="data">
                  <span v-if="data.item.fechaInicio != null && data.item.fechaInicio != 'null'">{{ data.item.fechaInicio }}</span>
                </template>

                <template #cell(_tipo)="data">
                  <span v-if="data.item.tipoGasto == 'anual'">Anual {{ data.item.tipoCobroAnual }}</span>
                  <span v-else>{{ data.item.tipoGasto.charAt(0).toUpperCase() + data.item.tipoGasto.slice(1) }}</span>
                </template>

                <template #cell(_iva)="data">
                  <span v-if="data.item.iva.length > 0">{{ data.item.iva }}%</span>
                </template>

              </b-table>
            </div>
          </div>
        </div>

        <b-modal id="modal-fecha-fin" :title="titleFechaFin" centered size="sm" hide-footer>

          <b-row>
            <b-col md="6">
              <b-form-group label="Mes de Fin (incluido)" label-for="v-fecha-mes-fin">
                <b-form-select v-model="mesFinSeleccionadoEdit" :options="meses" class="mb-2"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="6">
              <b-form-group label="Año de Fin (incluido)" label-for="v-fecha-ano-fin">
                <b-form-select v-model="anioFinSeleccionadoEdit" :options="anios"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <div style="text-align: center;">
            <b-button @click="guadarEditarFechaFin()" class="finish-button" style="background-color: #3bab76 !important;
                border-color: #3bab76 !important;">
              Guardar
            </b-button>
          </div>


        </b-modal>

        <b-modal id="modal-editar-gasto" :title="titleEditarGasto" centered size="xl" hide-footer>

          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Información</h5>
              <!--<small class="text-muted">Enter Your Personal Info.</small>-->
            </b-col>
            <b-col md="3">
              <b-form-group label="Nombre*" label-for="v-first-name">
                <b-form-input id="v-first-name" placeholder="" v-model="nombreEdit" />
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group label="Descripcion" label-for="v-last-name">
                <b-form-input id="v-last-name" placeholder="" v-model="descripcionEdit" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Empresa*" label-for="v-country">
                <v-select id="v-country" v-model="empresaSeleccionadaEdit" :options="empresas" label="text" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Categoria*" label-for="v-country">
                <v-select id="v-country" v-model="categoriaSeleccionadaEdit" :options="categorias" label="text" />
              </b-form-group>
            </b-col>
            <b-col md="2">
              <b-form-group label="Importancia" label-for="v-country">
                <v-select id="v-country" v-model="importanciaSeleccionadaEdit" :options="importanciaOpciones"
                  label="text" />
              </b-form-group>
            </b-col>
            <b-col md="2" v-if="tiposEdit.length > 0">
              <b-form-group label="Tipo Gasto" label-for="v-country">
                <v-select id="v-country" v-model="tiopoGastoSeleccionadoEdit" :options="tiposEdit" label="text" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12" class="mb-2">
              <h5 class="mb-0">Coste</h5>
            </b-col>
            <b-col md="4">
              <b-form-group label="Moneda*" label-for="v-moneda">
                <v-select id="v-moneda" v-model="monedaSeleccionadaEdit" :options="monedas" label="text" />
              </b-form-group>
            </b-col>
            <b-col md="4">
              <b-form-group label="Precio*" label-for="v-precio">
                <b-form-input id="v-precio" type="number" step="0.01" placeholder="Ingrese el precio"
                  v-model="precioEdit" @wheel.prevent />
              </b-form-group>
            </b-col>

            <b-col md="4">
              <b-form-group label="IVA %" label-for="v-iva">
                <b-form-input id="v-iva" type="number" placeholder="Ingrese el % de IVA" v-model="ivaEdit"
                  @wheel.prevent />
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="tipoGastoEdit === 'puntual' || tipoGastoEdit === 'anual'">
              <b-form-group label="Fecha*" label-for="v-fecha">
                <b-form-input id="v-fecha" type="date" placeholder="Ingrese la fecha" v-model="fechaEdit" />
              </b-form-group>
            </b-col>
            <b-col md="2" v-else> </b-col>

            <b-col md="4" v-if="tipoGastoEdit === 'anual'">
              <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
                <b-form-select v-model="tipoAnualCobroEdit" :options="optionsAnualCobro" class="mb-2"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="4" v-if="tipoGastoEdit === 'impuestos'">
              <b-form-group label="Tipo de cobro*" label-for="v-fecha-anual-tipo">
                <b-form-select v-model="tipoAnualCobroEdit" :options="optionsAnualCobroImpuestos"
                  class="mb-2"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="tipoGastoEdit === 'mensual'">
              <b-form-group label="Mes de Inicio*" label-for="v-fecha-mes-inicio">
                <b-form-select v-model="mesInicioSeleccionadoEdit" :options="meses" class="mb-2"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="tipoGastoEdit === 'mensual'">
              <b-form-group label="Año de Inicio*" label-for="v-fecha-ano-inicio">
                <b-form-select v-model="anioInicioSeleccionadoEdit" :options="anios"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="tipoGastoEdit === 'mensual'">
              <b-form-group label="Mes de Fin (incluido)" label-for="v-fecha-mes-fin">
                <b-form-select v-model="mesFinSeleccionadoEdit" :options="meses" class="mb-2"></b-form-select>
              </b-form-group>
            </b-col>

            <b-col md="2" v-if="tipoGastoEdit === 'mensual'">
              <b-form-group label="Año de Fin (incluido)" label-for="v-fecha-ano-fin">
                <b-form-select v-model="anioFinSeleccionadoEdit" :options="anios"></b-form-select>
              </b-form-group>
            </b-col>
          </b-row>

          <div style="text-align: center;">
            <b-button @click="guardarEditarGasto()" class="finish-button" style="background-color: #3bab76 !important;
            border-color: #3bab76 !important;">
              Guardar
            </b-button>
          </div>


        </b-modal>

      </b-tab>

      <b-tab>
        <div class="kpg__movimientos">
            <div class="kpg__mov-card">
              <div class="kpg__section-header" style="margin-bottom: 14px;">
                <i class="fa-solid fa-info-circle kpg__section-icon kpg__section-icon--info"></i>
                <span class="kpg__section-title">Ultima información: {{ lastInputGuille }}</span>
              </div>
              <div class="kpg__mov-inline">
                <b-form-input type="text" placeholder="nueva información..." v-model="inputGuille" />
                <button class="kpg__btn kpg__btn--primary" @click="guardarInputGuille()">Guardar</button>
              </div>
            </div>

            <div class="kpg__mov-card">
              <div class="kpg__section-header" style="margin-bottom: 14px;">
                <i class="fa-solid fa-cloud-arrow-up kpg__section-icon kpg__section-icon--success"></i>
                <span class="kpg__section-title">Importar CSV de Bancos</span>
              </div>
              <div class="kpg__mov-upload">
                <v-select v-model="selectedBank" :options="banks" label="text" style="flex: 1;" />
                <b-form-file v-model="csvInput" placeholder="Selecciona archivo..."
                  drop-placeholder="Suelta aqui..." style="flex: 1;" />
                <button class="kpg__btn kpg__btn--outline" @click="procesarFichero">Procesar</button>
              </div>
              <div style="margin-top: 12px;">
                <div v-if="!loadingRevolut && !loadingPaypal" class="kpg__mov-api-buttons">
                  <button class="kpg__btn kpg__btn--primary" @click="obtenerDatosRevolut">Obtener Revolut</button>
                  <button class="kpg__btn kpg__btn--primary" @click="obtenerDatosPaypal">Obtener Paypal <i class="fa-brands fa-paypal"></i></button>
                </div>
                <div v-else class="d-flex align-items-center">
                  <b-spinner small type="border" class="mr-2" />
                  <span>Cargando datos de <span v-if="loadingRevolut">Revolut</span><span v-else>Paypal</span>...</span>
                </div>
              </div>
            </div>

            <div class="kpg__mov-card">
              <app-collapse>
                <app-collapse-item :title="'Whitelist: ' + whiteListData.length">

                  <div class="kpg__mov-inline" style="margin-bottom: 10px;">
                    <b-form-input type="text" placeholder="Texto" v-model="newTextoWhiteList" style="flex: 1;" />
                    <button class="kpg__btn kpg__btn--outline" @click="addWhiteList()">Agregar</button>
                  </div>
                  <div class="kpg__table-card">
                    <b-table :items="whiteListData" :fields="columnasTableWhiteList"
                      class="kpg__table" no-border-collapse sort-icon-left>
                      <template #cell(_delete)="data">
                        <div class="kpg__actions">
                          <span class="kpg__action kpg__action--delete" @click="deleteWhiteList(data.item)">
                            <i class="fa-solid fa-trash"></i>
                          </span>
                        </div>
                      </template>
                    </b-table>
                  </div>

                </app-collapse-item>
              </app-collapse>
            </div>

            <div class="kpg__mov-card">
              <div class="kpg__section-header" style="margin-bottom: 14px;">
                <i class="fa-solid fa-money-bill-transfer kpg__section-icon kpg__section-icon--warning"></i>
                <span class="kpg__section-title">Gastos</span>
                <button class="kpg__btn kpg__btn--primary" style="margin-left: auto;" @click="aplicarReglas()">
                  <i class="fa-solid fa-gears"></i> Aplicar Reglas
                </button>
              </div>
              <div class="kpg__filters">
                <div class="kpg__filter-item kpg__filter-item--wide">
                  <label class="kpg__filter-label">Buscar</label>
                  <b-form-input type="text" placeholder="Buscar..." v-model="filtroTextoMovimiento" />
                </div>
                <div class="kpg__filter-item">
                  <label class="kpg__filter-label">Estado</label>
                  <v-select v-model="filtroFinalizadoMovimiento" :options="[{ value: 'Todos', text: 'Todos' },
                    { value: 'Finalizado', text: 'Finalizado' },
                    { value: 'Sin finalizar', text: 'Sin finalizar' }]" label="text" />
                </div>
                <div class="kpg__filter-item">
                  <label class="kpg__filter-label">Banco</label>
                  <v-select v-model="filtroBancoMovimiento" :options="banks" label="text" />
                </div>
                <div class="kpg__filter-item">
                  <label class="kpg__filter-label">Empresa</label>
                  <v-select v-model="filtroEmpresaMovimiento" :options="empresas" label="text" />
                </div>
              </div>
              <div class="kpg__table-card">
                <div class="kpg__tabla-scroll">
                  <b-table :items="formartedMovimientosItems" :fields="columnasMovimientoTable" :tbody-tr-class="rowClass"
                    class="kpg__table" no-border-collapse sort-icon-left hover>
                    <template #cell(_contabilizado)="data">
                      <span v-if="!data.item.contabilizado" class="kpg__pagado kpg__pagado--no"
                        @click="contabilizadoUpdate(data.item, true)">
                        <i class="fa-solid fa-xmark"></i>
                      </span>
                      <span v-else class="kpg__pagado kpg__pagado--si" @click="contabilizadoUpdate(data.item, false)">
                        <i class="fa-solid fa-check"></i>
                      </span>
                    </template>
                    <template #cell(_nuevoGasto)="data">
                      <button v-if="!data.item.contabilizado" class="kpg__btn kpg__btn--outline kpg__btn--sm"
                        @click="crearGastoDesdeMovimiento(data.item)">
                        Crear Gasto
                      </button>
                    </template>
                  </b-table>
                </div>
              </div>
            </div>
          </div>

      </b-tab>
      <b-tab>
        <ReglasComponente></ReglasComponente>
      </b-tab>

    </b-tabs>

  </div>
</template>

<script>
/**/

import { FormWizard, TabContent } from "vue-form-wizard";
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import { BRow, BCol, BFormGroup, BFormInput } from "bootstrap-vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import * as XLSX from 'xlsx';
import Papa from "papaparse";
import AppCollapse from '@core/components/app-collapse/AppCollapse.vue'
import AppCollapseItem from '@core/components/app-collapse/AppCollapseItem.vue'

import ReglasComponente from './kpiRules.vue'

import axios from '@axios'

export default {
  components: {
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    vSelect,
    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,
    AppCollapse,
    AppCollapseItem,
    ReglasComponente
  },
  data() {
    return {
      empresaSeleccionada: "",
      empresas: [
        { value: "Harber London", text: "Harber London" },
        { value: "Craft Lab", text: "Craft Lab" },
      ],
      categoriaSeleccionada: "",
      categorias: [
        { value: "Costes de venta", text: "Costes de venta" },
        { value: "Materiales", text: "Materiales" },
        { value: "Envios y devoluciones", text: "Envios y devoluciones" },
        { value: "Compra de productos", text: "Compra de productos" },
        { value: "Marketing", text: "Marketing" },
        { value: "Servicios", text: "Servicios" },
        { value: "Gastos de servicios", text: "Gastos de servicios" },
        { value: "Subscripciones", text: "Subscripciones" },
        { value: "Nominas", text: "Nominas" },
        { value: "Impuestos", text: "Impuestos" },
        { value: "Alquileres", text: "Alquileres" },
        { value: "Almacenamiento", text: "Almacenamiento" },
        { value: "Seguros", text: "Seguros" },
        { value: "Reparaciones", text: "Reparaciones" },
        { value: "Equipos Informaticos", text: "Equipos Informáticos" },
        { value: "Maquinaria", text: "Maquinaria" },
        { value: "Gastos de Oficina", text: "Gastos de Oficina" },
        { value: "Gastos de Fabrica", text: "Gastos de Fábrica" },
        { value: "Prestamos", text: "Prestamos" }
      ],
      newTextoWhiteList: '',
      monedaSeleccionada: "",
      monedas: [
        { value: "Euro", text: "Euro" },
        { value: "Dolar", text: "Dolar" },
        { value: "Libra", text: "Libra" },
      ],
      importanciaSeleccionada: "",
      importanciaOpciones: [
        { value: "Obligatorios", text: "Obligatorios" },
        { value: "Indispensables", text: "Indispensables" },
        { value: "Necesarios", text: "Necesarios" },
        { value: "Dispensables", text: "Dispensables" },
      ],
      tiposEdit: [
        { value: "puntual", text: "Puntual" },
        //{ value: "mensual", text: "Mensual" },
        { value: "anual", text: "Anual" },
        { value: "impuestos", text: "Impuestos" },
        { value: "nomina", text: "Nomina" },
        { value: "ads", text: "Ads" },
        { value: "envios", text: "Envios" },
      ],
      filtroImportancia: "",
      filtroCategorias: "",
      filtroTexto: "",
      filtroEmpresa: "",
      filtroTipo: "",
      tipos: [
        { value: "puntual", text: "Puntual" },
        //{ value: "mensual", text: "Mensual" },
        { value: "anual", text: "Anual" },
        { value: "impuestos", text: "Impuestos" },
        { value: "nomina", text: "Nomina" },
        { value: "ads", text: "Ads" },
        { value: "envios", text: "Envios" },
      ],
      tipoGasto: "",
      nombre: "",
      descripcion: "",
      precio: "",
      iva: "",
      fecha: "",
      fechaInicio: "",
      fechaFin: "",
      tipoAnualCobro: "",
      optionsAnualCobro: [
        { value: 'natural', text: 'Año Natural (1 Enero / 31 Diciembre)' },
        { value: 'retrospectivo anterior', text: 'Año Retrospectivo Anterior (15 Febrero 2025 / 15 Febrero 2024)' },
        { value: 'retrospectivo siguiente', text: 'Año Retrospectivo Siguiente (15 Febrero 2025 / 15 Febrero 2026)' },
      ],
      optionsAnualCobroImpuestos: [
        { value: 'mensual', text: 'Mensual (se proratea en el mes seleccionado)' },
        { value: 'trimestral', text: 'Trimestral (se proratea en 3 meses a partir del seleccionado)' },
        { value: 'semestral', text: 'Semestral (se proratea en 6 meses a partir del seleccionado)' },
        { value: 'retrospectivo anterior', text: 'Año Retrospectivo Anterior (15 Febrero 2025 / 15 Febrero 2024)' },
        { value: 'retrospectivo siguiente', text: 'Año Retrospectivo Siguiente (15 Febrero 2025 / 15 Febrero 2026)' },
      ],
      mesInicioSeleccionado: "",
      anioInicioSeleccionado: "",
      mesFinSeleccionado: "",
      anioFinSeleccionado: "",
      mesFinSeleccionadoEdit: "",
      anioFinSeleccionadoEdit: "",
      titleFechaFin: "Fecha fin",
      idEditFechaFin: 0,
      meses: [
        { value: '01', text: 'Enero' },
        { value: '02', text: 'Febrero' },
        { value: '03', text: 'Marzo' },
        { value: '04', text: 'Abril' },
        { value: '05', text: 'Mayo' },
        { value: '06', text: 'Junio' },
        { value: '07', text: 'Julio' },
        { value: '08', text: 'Agosto' },
        { value: '09', text: 'Septiembre' },
        { value: '10', text: 'Octubre' },
        { value: '11', text: 'Noviembre' },
        { value: '12', text: 'Diciembre' },
      ],
      anios: Array.from({ length: 16 }, (_, i) => {
        const year = new Date().getFullYear() - 5 + i;
        return { value: year, text: year };
      }),
      allPagos: [],
      pagosBusqueda: "",
      columnasTable: [
        {
          key: "_edit",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },
        {
          key: "nombre",
          label: "nombre",
          sortable: true,
        },
        {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "empresa",
          label: "Empresa",
          sortable: true,
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "_fechaInicio",
          label: "Fecha Inicio",
          sortable: true,
        },
        {
          key: "_fechaFin",
          label: "Fecha Fin",
          sortable: true,
        },
        {
          key: "categoria",
          label: "Categoria",
          sortable: true,
        },
        {
          key: "_tipo",
          label: "Tipo",
          sortable: true,
        },
        {
          key: "moneda",
          label: "Moneda",
          sortable: true,
        },
        {
          key: "precio",
          label: "Precio",
          sortable: true,
        },
        {
          key: "_iva",
          label: "IVA",
          sortable: true,
        },
        {
          key: "importancia",
          label: "Importancia",
          sortable: true,
        },
        {
          key: "options",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },

      ],
      whiteListData: [],
      columnasTableWhiteList: [
        {
          key: "_delete",
          label: "",
          sortable: false,
          thStyle: { width: "1%" },
        },
        {
          key: "nombre",
          label: "nombre",
          sortable: true,
        },
      ],
      fechaActual: "",
      titleEditarGasto: "",
      //Edit
      nombreEdit: "",
      descripcionEdit: "",
      empresaSeleccionadaEdit: "",
      categoriaSeleccionadaEdit: "",
      monedaSeleccionadaEdit: "",
      importanciaSeleccionadaEdit: "",
      tiopoGastoSeleccionadoEdit: "",
      precioEdit: "",
      ivaEdit: "",
      fechaEdit: "",
      fechaInicioEdit: "",
      fechaFinEdit: "",
      tipoAnualCobroEdit: "",
      tipoGastoEdit: "",
      mesInicioSeleccionadoEdit: "",
      anioInicioSeleccionadoEdit: "",
      mesFinSeleccionadoEdit: "",
      anioFinSeleccionadoEdit: "",
      idEdit: 0,
      banks: [
        {
          value: "Ibercaja", text: "Ibercaja", typeFile: 'xls', empresa: 'Craft Lab',
          cFecha: 1, cDescripcion: 4, cConcepto: 3, cPrecio: 6, divisa: 'EUR'
        },
        /*{
          value: "Revolut", text: "Revolut", typeFile: 'csv', empresa: 'Harber London',
          cFecha: 0, cDescripcion: 7, cConcepto: 8, cPrecio: 17, divisa: 'GBP'
        },*/
        {
          value: "HSBC Diario", text: "HSBC Diario", typeFile: 'csv', empresa: 'Harber London',
          cFecha: 0, cDescripcion: 2, cConcepto: 1, cPrecio: 3, divisa: 'GBP'
        },
        /*{   
            value: "HSBC", text: "HSBC Mensual", typeFile: 'csv', empresa: 'Harber London',
            cFecha: 0, cDescripcion: 2, cConcepto: 1, cPrecio: 3, cPrecioIn: 4, divisa: 'GBP' 
        },*/
        {
          value: "Sabadell", text: "Sabadell", typeFile: 'xls', empresa: 'Craft Lab',
          cFecha: 0, cDescripcion: 1, cConcepto: 5, cPrecio: 3, divisa: 'EUR'
        },
        {
          value: "Sabadell Tarjetas", text: "Sabadell Tarjetas", typeFile: 'xls', empresa: 'Craft Lab',
          cFecha: 0, cDescripcion: 1, cConcepto: 2, cPrecio: 4, divisa: 'EUR'
        },
        {
          value: "Sabadell Envios", text: "Sabadell Envios", typeFile: 'xls', empresa: 'Craft Lab',
          cFecha: 0, cDescripcion: 1, cConcepto: 5, cPrecio: 3, divisa: 'EUR'
        },
        /*{
          value: "Paypal", text: "Paypal", typeFile: '', empresa: 'Harber London',
          cFecha: 0, cDescripcion: 0, cConcepto: 0, cPrecio: 0, divisa: 'GBP'
        },*/
      ],
      selectedBank: null,
      csvInput: [],
      data: [],
      allMovimientos: [],
      allMovimientosBusqueda: [],
      columnasMovimientoTable: [
        {
          key: "_contabilizado",
          label: "Check",
          sortable: true,
          thStyle: { width: "1%" },
        },
        {
          key: "banco",
          label: "Banco",
          sortable: true,
        },
        {
          key: "precio",
          label: "Precio",
          sortable: true,
        },
        {
          key: "descripcion",
          label: "Descripcion",
          sortable: true,
        },
        {
          key: "concepto",
          label: "Concepto",
          sortable: true,
        },
        {
          key: "fecha",
          label: "Fecha",
          sortable: true,
        },
        {
          key: "_nuevoGasto",
          label: "",
          sortable: true,
        },


      ],
      movimientoSeleccionado: {
        descripcion: '',
        concepto: '',
        id: 0
      },
      filtroBancoMovimiento: "",
      filtroTextoMovimiento: "",
      filtroEmpresaMovimiento: "",
      filtroDesdeMovimiento: "",
      filtroHastaMovimiento: "",
      filtroFinalizadoMovimiento: { value: 'Todos', text: 'Todos' },
      inputGuille: '',
      lastInputGuille: '',
      loadingRevolut: false,
      loadingPaypal: false,
      allRules: [],
      activeTab: 0,
      cargandoPrimeraVez: true

    };
  },
  computed: {
    formartedItemsVariant() {
      if (!this.pagosBusqueda) return []
      return this.pagosBusqueda.map(item => {
        item._rowVariant = this.getVariant(item)
        return item
      })
    },
    formartedItems() {
      if (!this.pagosBusqueda) return []
      return this.pagosBusqueda.map(item => {
        item._customClass = this.getCustomClass(item)
        return item
      })
    },
    formartedMovimientosItems() {

      return this.allMovimientos
        .filter(item => {
          if (item.precio < 0) return false;

          const matchesFinalizado = this.filtroFinalizadoMovimiento.value === 'Finalizado' ? item.contabilizado :
            this.filtroFinalizadoMovimiento.value === 'Sin finalizar' ? !item.contabilizado :
              true;

          const matchesTexto = item.concepto.toLowerCase().includes(this.filtroTextoMovimiento.toLowerCase()) ||
            item.descripcion.toLowerCase().includes(this.filtroTextoMovimiento.toLowerCase());

          const matchesEmpresa = this.filtroEmpresaMovimiento ? item.empresa === this.filtroEmpresaMovimiento.value : true;

          const matchesBanco = this.filtroBancoMovimiento ? item.banco === this.filtroBancoMovimiento.value : true;

          return matchesFinalizado && matchesTexto && matchesEmpresa && matchesBanco;
        })
        .map(item => {
          let classItem = item.tipoGasto ? 'gasto-' + item.tipoGasto : '';
          if (classItem == '')
            item._rowVariant = item.contabilizado ? 'secondary' : '';
          item._customClass = classItem;
          return item;
        });


    }
  },
  methods: {
    getVariant(item) {

        /*if(item.finalizado)
          return 'secondary';
        else */if (item.tipoGasto == "puntual")
        return 'success';
      else if (item.tipoGasto == "mensual")
        return 'warning';
      else if (item.tipoGasto == "anual")
        return 'primary';
      else if (item.tipoGasto == "nomina")
        return 'secondary';
      else if (item.tipoGasto == "impuestos")
        return 'danger';
      else if (item.tipoGasto == "ads")
        return 'info';
      else if (item.tipoGasto == "envios")
        return 'dark';


    },
    getCustomClass(item) {

      if (item.fechaFin) {
        const fechaFin = new Date(item.fechaFin);
        const hoy = new Date();

        // Si la fecha actual es mayor que fechaFin, consideramos finalizado
        if (hoy > fechaFin) {
          return 'gasto-finalizado';
        }
      }

      switch (item.tipoGasto) {
        case "puntual":
          return 'gasto-puntual'
        case "mensual":
          return 'gasto-mensual'
        case "anual":
          return 'gasto-anual'
        case "nomina":
          return 'gasto-nomina'
        case "impuestos":
          return 'gasto-impuestos'
        case "ads":
          return 'gasto-ads'
        case "envios":
          return 'gasto-envios'
        default:
          return ''

      }

    },
    rowClass(item) {
      if (!item) return ''

      if (item.fechaFin) {
        const fechaFin = new Date(item.fechaFin);
        const hoy = new Date();

        if (hoy > fechaFin) {
          return 'gasto-finalizado';
        }
      }


      switch (item.tipoGasto) {
        case "puntual":
          return 'gasto-puntual'
        case "mensual":
          return 'gasto-mensual'
        case "anual":
          return 'gasto-anual'
        case "nomina":
          return 'gasto-nomina'
        case "impuestos":
          return 'gasto-impuestos'
        case "ads":
          return 'gasto-ads'
        case "envios":
          return 'gasto-envios'
        default:
          return ''
      }
    },
    getRadioColor(tipo) {
      //console.log(tipo);
      switch (tipo) {
        case 'puntual': return '#28a745';    // verde
        case 'mensual': return '#ffc107';    // amarillo
        case 'anual': return '#007bff';      // azul
        case 'nomina': return '#ff66cc';     // rosa (tu nuevo color)
        case 'impuestos': return '#dc3545';  // rojo
        case 'ads': return '#17a2b8';        // cyan
        case 'envios': return '#343a40';     // gris oscuro
        default: return '#000000';            // negro por defecto
      }
    },
    loadMovimientos() {

      Promise.all([
        axios.get("/kpi/banco"),
        axios.get("/kpi/bancos"),
      ]).then(responses => {
        const [bancoResponse, bancosResponse] = responses;

        // Normalizar fechas según el banco
        this.allMovimientos = bancoResponse.data.map(item => {
          let fechaPartes = item.fecha.split('T')[0].split('-');

          // Si el banco es Ibercaja o Sabadell, corregir el formato de YYYY-DD-MM a YYYY-MM-DD

          item.fecha = fechaPartes.join('-'); // Mantener el formato original para los demás


          return item;
        });

        //console.log(this.allMovimientos);

        // Ordenar por fecha descendente
        this.allMovimientos.sort((a, b) => new Date(b.fecha) - new Date(a.fecha));

        // Obtener el último movimiento por banco
        const ultimosMovimientos = this.allMovimientos.reduce((acc, mov) => {
          if (!acc[mov.banco]) {
            acc[mov.banco] = mov;
          }
          return acc;
        }, {});

        // Mapear bancos y agregar la info del último movimiento
        this.banks = this.banks.map(bank => {
          const movimiento = ultimosMovimientos[bank.value];

          if (movimiento) {
            // Convertir fecha a DD-MM-YYYY para mostrarla correctamente
            let [year, month, day] = movimiento.fecha.split('-');
            let fechaMostrada = `${day}-${month}-${year}`;

            return {
              ...bank,
              text: `${bank.text} | ${fechaMostrada} | ${movimiento.precio} | ${movimiento.descripcion}`
            };
          } else {
            return { ...bank };
          }
        });
      });



      /*Promise.all([
                    axios.get("/kpi/banco"),
                    axios.get("/kpi/bancos"),
                ]).then(responses => {
                  const [bancoResponse, bancosResponse] = responses;
                  this.allMovimientos = bancoResponse.data.map(item => {
                        item.fecha = item.fecha.split('T')[0];
                        item.fecha = item.fecha.split('-')[2] + '-' + item.fecha.split('-')[1] + '-' + item.fecha.split('-')[0];
                        return item;
                    });


                    this.banks = this.banks.map(bank => {
                        const movimiento = bancosResponse.data.find(m => m.banco === bank.value);

                        if(movimiento != undefined){

                          let fechaParseada = '';
                          fechaParseada = movimiento.fecha.split('T')[0];
                          fechaParseada = fechaParseada.split('-')[2] + '-' + fechaParseada.split('-')[1] + '-' + fechaParseada.split('-')[0];

                          return {
                              ...bank,
                              text: movimiento 
                                  ? `${bank.text} | ${fechaParseada} | ${movimiento.precio} | ${movimiento.descripcion}` 
                                  : bank.text
                          };
                        }
                        else{
                          return {
                          ...bank}
                        }
                    });

                });*/

    },
    loadItems() {

      axios.post("/uso", { seccion: "kpi-gastos" });

      this.fechaActual = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate());

      this.loadMovimientos();
      Promise.all([
        axios.get("/kpi/pagos"),
        axios.get("/kpi/whiteList"),
        axios.get("/kpi/inputGuille"),
        axios.get("/kpi/rules"),
      ]).then(responses => {
        const [pagosResponse, whiteList, inputGuilleResponse, rulesResponse] = responses;

        this.allRules = rulesResponse.data;

        this.lastInputGuille = inputGuilleResponse.data[0].texto;

        this.allPagos = pagosResponse.data.reverse();
        this.pagosBusqueda = pagosResponse.data;

        this.whiteListData = whiteList.data;

        this.allPagos.forEach(item => {

          function resetTime(date) {
            return new Date(date.getFullYear(), date.getMonth(), date.getDate());
          }

          if (item.tipoGasto == "puntual") {
            let fecha = new Date(item.fecha);
            fecha = resetTime(fecha);
            if (this.fechaActual > fecha)
              item.finalizado = true;
            else
              item.finalizado = false;
          }
          else if (item.tipoGasto == "mensual") {
            let fechaInicioPago = new Date(item.fechaInicio);
            fechaInicioPago = resetTime(fechaInicioPago);
            if (this.fechaActual >= fechaInicioPago) {
              if (item.fechaFin == "")
                item.finalizado = false;
              else {
                let fechaFinPago = new Date(item.fechaFin);
                fechaFinPago = resetTime(fechaFinPago);
                item.finalizado = true;
                if (this.fechaActual <= fechaFinPago)
                  item.finalizado = false;
              }

            }
          }
          else if (item.tipoGasto == "anual") {

            let fechaInicioPago = "";
            let fechaFinPago = "";

            let fechaAnual = new Date(item.fecha);
            if (item.tipoCobroAnual == 'natural') {
              fechaInicioPago = new Date(fechaAnual.getFullYear(), 1, 1);
              fechaFinPago = new Date(fechaAnual.getFullYear(), 12, 31);
              item.finalizado = true;

              if (this.fechaActual >= fechaInicioPago && this.fechaActual <= fechaFinPago)
                item.finalizado = false;
            }
            else if (item.tipoCobroAnual == 'retrospectivo anterior') {
              fechaInicioPago = new Date(fechaAnual);
              fechaFinPago = new Date(fechaInicioPago);
              fechaFinPago.setFullYear(fechaFinPago.getFullYear() - 1);
              item.finalizado = true;

              if (this.fechaActual <= fechaInicioPago && this.fechaActual >= fechaFinPago)
                item.finalizado = false;
            }
            else if (item.tipoCobroAnual == 'retrospectivo siguiente') {
              fechaInicioPago = resetTime(fechaAnual);
              fechaFinPago = resetTime(fechaInicioPago);
              fechaFinPago.setFullYear(fechaFinPago.getFullYear() + 1);
              item.finalizado = true;

              if (this.fechaActual >= fechaInicioPago && this.fechaActual <= fechaFinPago)
                item.finalizado = false;
            }
            else
              item.finalizado = true;

          }

        });

        this.allPagos.sort((a, b) => {
          // Primero ordenar por "finalizado" (false primero, true al final)
          if (a.finalizado !== b.finalizado) {
            return a.finalizado - b.finalizado;
          }
          // Si tienen el mismo estado de "finalizado", ordenar por ID
          return b.id - a.id;
        });

        this.cargandoPrimeraVez = false;

        this.cargarFiltro();

      });
    },
    formSubmitted() {

      let fechaInicio = "";
      let fechaFin = "";

      let tipoCobroAnual = "";

      if (this.tipoGasto === 'mensual') {
        fechaInicio = this.anioInicioSeleccionado + "-" + this.mesInicioSeleccionado + "-01";

        if (this.anioFinSeleccionado != "" && this.mesFinSeleccionado != "") {
          const year = this.anioFinSeleccionado;
          const month = this.mesFinSeleccionado; // Asegúrate de que es 1-12

          // Obtener el último día del mes seleccionado
          const lastDay = new Date(year, month, 0).getDate();

          // Formatear la fecha correctamente
          fechaFin = `${year}-${String(month).padStart(2, "0")}-${lastDay}`;
          //fechaFin = this.anioFinSeleccionado + "-" + this.mesFinSeleccionado + "-01";
        }
      }
      else if (this.tipoGasto === 'anual' || this.tipoGasto === 'impuestos') {

        tipoCobroAnual = this.tipoAnualCobro;
      }

      let data = {
        nombre: this.nombre,
        descripcion: this.descripcion,
        empresa: this.empresaSeleccionada.value,
        categoria: this.categoriaSeleccionada.value,
        moneda: this.monedaSeleccionada.value,
        precio: this.precio,
        iva: this.iva,
        fecha: this.fecha,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
        tipoGasto: this.tipoGasto,
        tipoCobroAnual: tipoCobroAnual,
        importancia: this.importanciaSeleccionada.value
      };

      axios
        .post("/kpi/pagos", { data })
        .then(response => {
          return response.data;
        })
        .then(res => {

          data.id = res.id;

          this.allPagos.push(data);

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Pago guarado correctamente",
              icon: "EditIcon",
              variant: "success",
            },
          });

          if (this.movimientoSeleccionado.id != 0) {
            this.movimientoSeleccionado.idKpiPago = data.id;
            this.movimientoSeleccionado.contabilizado = true;

            axios
              .put("/kpi/banco", this.movimientoSeleccionado)
              .then(response => {
                return response.data;
              })
              .then(res => {

              });

            this.activeTab = 1;
          }

          this.resetWizard();

        })

    },
    addWhiteList() {

      axios
        .post("/kpi/whiteList", { data: this.newTextoWhiteList })
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.whiteListData.push({ nombre: this.newTextoWhiteList, id: res.insertId });
          this.newTextoWhiteList = "";
        });

    },
    deleteWhiteList(data) {

      axios
        .delete("/kpi/whiteList/" + data.id)
        .then(response => {
          return response.data;
        })
        .then(res => {

          this.whiteListData = this.whiteListData.filter(dato => dato.id !== data.id);

        });
    },
    resetWizard() {
      this.nombre = "";
      this.descripcion = "";
      this.empresaSeleccionada = "";
      this.categoriaSeleccionada = "";
      this.monedaSeleccionada = "";
      this.precio = "";
      this.iva = "";
      this.fecha = "";
      this.fechaInicio = "";
      this.fechaFin = "";
      this.tipoGasto = "";
      this.tipoCobroAnual = "";
      this.importanciaSeleccionada = "";

      this.anioInicioSeleccionado = "";
      this.mesInicioSeleccionado = "";
      this.anioFinSeleccionado = "";
      this.mesFinSeleccionado = "";

      this.movimientoSeleccionado = {
        descripcion: '',
        concepto: '',
        id: 0
      };


      this.$refs.wizardPago.reset();
    },
    atrasPaso(props) {

      if (props.activeTabIndex == 3 && (this.tipoGasto == "nomina" || this.tipoGasto == "impuestos" || this.tipoGasto == "ads")) {
        props.prevTab();
        props.prevTab();
      }
      else
        props.prevTab();

    },
    siguientePaso(props) {

      function toastShow(title, self) {
        self.$toast({
          component: ToastificationContent,
          props: {
            title: title,
            icon: "EditIcon",
            variant: "danger",
          },
        });
      }

      //Paso 1
      if (props.activeTabIndex == 0) {
        if (this.tipoGasto != "") {
          props.nextTab();
        }
        else {
          toastShow("Selecciona el tipo de gasto", this);
        }
      }

      //Paso 2
      if (props.activeTabIndex == 1 && this.tipoGasto != "nomina" && this.tipoGasto != "ads" && this.tipoGasto != "impuestos") {
        let continuar = true;
        if (this.nombre == "") {
          continuar = false;
          toastShow("Rellena el nombre", this);
        }

        if (this.empresaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la empresa", this);
        }

        if (this.categoriaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la categoria", this);
        }

        if (continuar)
          props.nextTab();
      }

      //Paso 2 Nomina
      if (props.activeTabIndex == 1 && this.tipoGasto == "nomina") {
        let continuar = true;
        if (this.precio == "") {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if (this.fecha == "") {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }

        if (continuar) {
          this.descripcion = "Nomina";
          this.categoriaSeleccionada = this.categorias[8];
          this.importanciaSeleccionada = this.importanciaOpciones[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 2 Nomina
      if (props.activeTabIndex == 1 && this.tipoGasto == "impuestos") {
        let continuar = true;
        if (this.precio == "") {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if (this.fecha == "") {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }

        if (this.empresaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la empresa", this);
        }

        if (this.tipoAnualCobro == "") {
          continuar = false;
          toastShow("Rellena el tipo de cobro", this);
        }

        if (this.monedaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }

        if (continuar) {
          this.descripcion = "Impuestos";
          this.categoriaSeleccionada = this.categorias[9];
          this.importanciaSeleccionada = this.importanciaOpciones[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 2 ads
      if (props.activeTabIndex == 1 && this.tipoGasto == "ads") {
        let continuar = true;
        if (this.precio == "") {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if (this.fecha == "") {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }

        if (this.monedaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }



        if (continuar) {
          this.descripcion = "Ads";
          this.categoriaSeleccionada = this.categorias[4];
          this.importanciaSeleccionada = this.importanciaOpciones[2];
          this.empresaSeleccionada = this.empresas[0];

          props.nextTab();
          props.nextTab();
        }
      }

      //Paso 3
      if (props.activeTabIndex == 2) {
        let continuar = true;

        if (this.monedaSeleccionada == "") {
          continuar = false;
          toastShow("Rellena la moneda", this);
        }

        if (this.precio == "") {
          continuar = false;
          toastShow("Rellena el precio", this);
        }

        if (this.fecha == "" && (this.tipoGasto === 'puntual' || this.tipoGasto === 'anual')) {
          continuar = false;
          toastShow("Rellena la fecha", this);
        }

        if (this.tipoAnualCobro == "" && this.tipoGasto === 'anual') {
          continuar = false;
          toastShow("Rellena el tipo de cobro anual", this);
        }

        if (this.mesInicioSeleccionado == "" && this.tipoGasto === 'mensual') {
          continuar = false;
          toastShow("Rellena el mes de inicio", this);
        }

        if (this.anioInicioSeleccionado == "" && this.tipoGasto === 'mensual') {
          continuar = false;
          toastShow("Rellena el año de inicio", this);
        }

        if (continuar)
          props.nextTab();
      }

    },
    deletePago(item) {
      this.$swal({
        title: 'Estas seguro que quieres el pago: ' + item.nombre,
        icon: 'error',
        showCancelButton: true,
        //html: `<input type="text" id="motivo" class="swal2-input" placeholder="Motivo">`,
        confirmButtonText: 'Si, borrar',
        cancelButtonText: 'No',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {

        if (result.isConfirmed) {

          axios
            .delete("/kpi/pagos/" + item.id)
            .then(response => {
              return response.data;
            })
            .then(res => {

              this.allPagos = this.allPagos.filter(pago => pago.id !== item.id);
              this.pagosBusqueda = this.pagosBusqueda.filter(pago => pago.id !== item.id);

            });

          /*axios
          .delete("/finanzas/gastos/"+id)
          .then(response => {
            return response.data;
          })
          .then(res => {
              //this.listadoFacturas
              this.$swal({
                  icon: 'success',
                  title: 'La factura se ha borrado correctamente: ' + codigo,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })

              this.listadoFacturas = this.listadoFacturas.filter(item => item.id !== id);
              this.facturasBusqueda = this.facturasBusqueda.filter(item => item.id !== id);
              this.calcularResumen();
              this.buscarFuncion();
            }).
            catch(execption => {
              this.$swal({
                  icon: 'danger',
                  title: 'Se ha producido un error al borrar la factura.' ,
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
              })
            });*/

        }

      })

    },
    editPago(item) {
      this.titleEditarGasto = "Editar " + item.nombre;
      this.idEdit = item.id;
      this.nombreEdit = item.nombre;
      this.descripcionEdit = item.descripcion;
      this.empresaSeleccionadaEdit = this.empresas.find(e => e.value === item.empresa);
      this.categoriaSeleccionadaEdit = this.categorias.find(e => e.value === item.categoria);
      this.monedaSeleccionadaEdit = this.monedas.find(e => e.value === item.moneda);
      this.importanciaSeleccionadaEdit = this.importanciaOpciones.find(e => e.value === item.importancia);
      this.precioEdit = item.precio;
      this.ivaEdit = item.iva;
      this.fechaEdit = item.fecha;
      this.fechaInicioEdit = item.fechaInicio;
      this.tipoGastoEdit = item.tipoGasto;
      this.tipoAnualCobroEdit = item.tipoCobroAnual;
      this.tiopoGastoSeleccionadoEdit = "";

      /*
       { value: "puntual", text: "Puntual" },
        { value: "mensual", text: "Mensual" },
        { value: "anual", text: "Anual" },
        { value: "impuestos", text: "Impuestos" },
        { value: "nomina", text: "Nomina" },
        { value: "ads", text: "Ads" },
        { value: "envios", text: "Envios" },
      */

      if (this.tipoGastoEdit == 'puntual' || this.tipoGastoEdit == 'envios') {
        this.tiposEdit = [
          { value: "puntual", text: "Puntual" },
          { value: "envios", text: "Envios" }
        ];
      }
      else {
        this.tiposEdit = [];
      }

      if (this.tipoGastoEdit == 'mensual') {

        this.mesInicioSeleccionadoEdit = this.meses[new Date(item.fechaInicio).getMonth()].value;
        this.anioInicioSeleccionadoEdit = new Date(item.fechaInicio).getFullYear();

        if (item.fechaFin != null && item.fechaFin != "" && item.fechaFin != "null") {
          this.anioFinSeleccionadoEdit = new Date(item.fechaFin).getFullYear();
          this.mesFinSeleccionadoEdit = this.meses[new Date(item.fechaFin).getMonth()].value;
        }
      }
      else {
        this.mesInicioSeleccionadoEdit = "";
        this.anioInicioSeleccionadoEdit = "";

        this.anioFinSeleccionadoEdit = "";
        this.mesFinSeleccionadoEdit = "";
      }
      this.$bvModal.show('modal-editar-gasto');
    },
    guardarEditarGasto() {
      let fechaInicio = "";
      let fechaFin = "";

      let tipoCobroAnual = "";

      if (this.tipoGastoEdit === 'mensual') {
        fechaInicio = this.anioInicioSeleccionadoEdit + "-" + this.mesInicioSeleccionadoEdit + "-01";

        if (this.anioFinSeleccionadoEdit != "" && this.mesFinSeleccionadoEdit != "") {
          const year = this.anioFinSeleccionadoEdit;
          const month = this.mesFinSeleccionadoEdit; // Asegúrate de que es 1-12

          // Obtener el último día del mes seleccionado
          const lastDay = new Date(year, month, 0).getDate();

          // Formatear la fecha correctamente
          fechaFin = `${year}-${String(month).padStart(2, "0")}-${lastDay}`;
        }
      }
      else if (this.tipoGastoEdit === 'anual' || this.tipoGastoEdit === 'impuestos') {
        tipoCobroAnual = this.tipoAnualCobroEdit;
      }

      if (this.tiposEdit.length > 0 && this.tiopoGastoSeleccionadoEdit != '') {
        this.tipoGastoEdit = this.tiopoGastoSeleccionadoEdit;
      }

      let importancia = this.importanciaSeleccionadaEdit ? this.importanciaSeleccionadaEdit.value : "";

      let data = {
        id: this.idEdit,
        nombre: this.nombreEdit,
        descripcion: this.descripcionEdit,
        empresa: this.empresaSeleccionadaEdit.value,
        categoria: this.categoriaSeleccionadaEdit.value,
        moneda: this.monedaSeleccionadaEdit.value,
        precio: this.precioEdit,
        iva: this.ivaEdit,
        fecha: this.fechaEdit,
        fechaInicio: fechaInicio,
        fechaFin: fechaFin,
        tipoGasto: this.tipoGastoEdit,
        tipoCobroAnual: tipoCobroAnual,
        importancia: importancia
      };

      axios
        .put("/kpi/pagos/update", { data })
        .then(response => {
          return response.data;
        })
        .then(res => {
          const pago = this.allPagos.find(p => p.id === this.idEdit);
          if (pago) {
            Object.assign(pago, data);
          }

          this.$bvModal.hide('modal-editar-gasto');

          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Pago editado correctamente",
              icon: "EditIcon",
              variant: "success",
            },
          });
        });
    },
    editarFechaPagado(item) {
      this.titleFechaFin = "Fecha fin de " + item.nombre;
      this.idEditFechaFin = item.id;
      this.$bvModal.show('modal-fecha-fin');
    },
    guadarEditarFechaFin() {
      let fechaFin = "";

      // Obtener el último día del mes seleccionado
      const lastDay = new Date(this.anioFinSeleccionadoEdit, this.mesFinSeleccionadoEdit, 0).getDate();

      // Formatear la fecha correctamente
      fechaFin = `${this.anioFinSeleccionadoEdit}-${String(this.mesFinSeleccionadoEdit).padStart(2, "0")}-${lastDay}`;

      let data = {
        id: this.idEditFechaFin,
        fechaFin,
      }

      this.allPagos.find

      axios
        .put("/kpi/fechaFin", data)
        .then(response => {
          return response.data;
        })
        .then(res => {

          const pago = this.allPagos.find(p => p.id === this.idEditFechaFin);
          if (pago) {
            pago.fechaFin = fechaFin;
          }


        });
    },
    buscarFiltro() {
      this.pagosBusqueda = [];

      this.pagosBusqueda = this.allPagos.filter(pago => {
        const matchesTexto = pago.nombre.toLowerCase().includes(this.filtroTexto.toLowerCase()) ||
          pago.descripcion.toLowerCase().includes(this.filtroTexto.toLowerCase());
        const matchesTipo = this.filtroTipo ? pago.tipoGasto === this.filtroTipo.value : true;
        const matchesEmpresa = this.filtroEmpresa ? pago.empresa === this.filtroEmpresa.value : true;
        const matchesCategoria = this.filtroCategorias ? pago.categoria === this.filtroCategorias.value : true;
        const matchesImportancia = this.filtroImportancia ? pago.importancia === this.filtroImportancia.value : true;

        return matchesTexto && matchesTipo && matchesEmpresa && matchesCategoria && matchesImportancia;
      });

    },
    procesarFichero() {
      if (this.selectedBank == null)
        return;

      if (this.csvInput.name.includes('.xls')) {
        this.procesarXls();
      }
      else {
        this.procesarCsv();
      }

    },
    procesarCsv() {
      var reader = new FileReader();

      reader.onload = (e) => {
        let csvText = reader.result;

        let jsonData = Papa.parse(csvText, {
          delimiter: ",",
          quoteChar: '"',
          header: true,
          skipEmptyLines: true
        }).data;

        this.data = this.parseDatos(jsonData);

        this.guardarDatos(this.data);
      }

      reader.readAsText(this.csvInput);
    },
    procesarXls() {

      var reader = new FileReader();

      reader.onload = (e) => {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: 'array' });

        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        const jsonData = XLSX.utils.sheet_to_json(sheet);

        this.data = this.parseDatos(jsonData);

        this.guardarDatos(this.data);
      };

      reader.readAsArrayBuffer(this.csvInput);
    },
    parseDatos(datos) {

      let newDatos = datos.map(row => {

        let rawValue = Object.values(row)[this.selectedBank.cPrecio];
        let precio = parseFloat(String(rawValue).replace(',', '.'));

        let fecha = Object.values(row)[this.selectedBank.cFecha];

        if (this.selectedBank.value == 'HSBC') {
          if (Object.values(row)[this.selectedBank.cPrecio])
            precio = parseFloat(Object.values(row)[this.selectedBank.cPrecio]);
          else if (Object.values(row)[this.selectedBank.cPrecioIn])
            precio = -parseFloat(Object.values(row)[this.selectedBank.cPrecioIn]);
        }

        if (this.selectedBank.value == 'HSBC Diario') {
          //precio = -parseFloat(Object.values(row)[this.selectedBank.cPrecio]);
          precio = Math.abs(parseFloat(Object.values(row)[this.selectedBank.cPrecio]));

        }

        if (this.selectedBank.value == 'Sabadell Tarjetas') {
          const [dia, mes] = Object.values(row)[this.selectedBank.cFecha].split('/').map(Number);
          const fechaActual = new Date();
          let año = fechaActual.getFullYear();

          let fechaConAño = new Date(año, mes - 1, dia);

          if (fechaConAño > fechaActual) {
            año -= 1;
            fechaConAño = new Date(año, mes - 1, dia);
          }

          fecha = fechaConAño;
        }

        if (this.selectedBank.value == 'Ibercaja' || this.selectedBank.value == 'Revolut' || this.selectedBank.value == 'Sabadell' || this.selectedBank.value == 'Sabadell Envios') {
          if (Object.values(row)[this.selectedBank.cPrecio])
            precio = -parseFloat(Object.values(row)[this.selectedBank.cPrecio]);
        }

        let newData = {
          fecha: fecha,
          descripcion: Object.values(row)[this.selectedBank.cDescripcion],
          concepto: Object.values(row)[this.selectedBank.cConcepto],
          precio: precio,
          divisa: this.selectedBank.divisa,
          banco: this.selectedBank.value,
          empresa: this.selectedBank.empresa,
          contabilizado: false,
          idKpiPago: 0
        }


        //Aqui agregar codigo whitelist para el contabilizado = true;
        this.whiteListData.forEach(whiteList => {
          if ((newData.descripcion?.toLowerCase().includes(whiteList.nombre.toLowerCase()) || newData.concepto?.toLowerCase().includes(whiteList.nombre.toLowerCase())))
            newData.contabilizado = true;
        });

        if (this.selectedBank.value == 'Sabadell' || this.selectedBank.value == 'Sabadell Envios') {
          let fechaString = newData.fecha;
          let [dia, mes, año] = fechaString.split("/");
          newData.fecha = new Date(`${año}-${mes}-${dia}`);
        }
        else if (this.selectedBank.value == 'Ibercaja') {
          if (newData.fecha != undefined && newData.fecha.includes("-")) {
            let fechaString = newData.fecha;
            let [dia, mes, año] = fechaString.split("-");
            newData.fecha = new Date(`${año}-${mes}-${dia}`);
          }
        }
        else
          newData.fecha = new Date(newData.fecha);

        return newData;

      });

      return newDatos.filter(item =>
        item &&
        item.precio !== undefined &&
        !isNaN(parseFloat(item.precio)) &&
        parseFloat(item.precio) != 0
      );

    },
    aplicarReglas() {

      let kpiPagosArray = [];
      let kpiMovimientoArray = [];

      Promise.all([
        axios.get("/kpi/rules")
      ]).then(responses => {

        const [ rulesResponse] = responses;

        this.allRules = rulesResponse.data;

        for (const rule of this.allRules) {
          for (const data of this.allMovimientos.filter(item => item.contabilizado == false)) {
            if (
              data.descripcion.toLowerCase().includes(rule.textoRequisito.toLowerCase()) &&
              (rule.bancoRequisito === 'Todos' || data.banco.toLowerCase() === rule.bancoRequisito.toLowerCase()) &&
              (rule.precioMinRequisito === '' || data.precio >= parseFloat(rule.precioMinRequisito)) &&
              (rule.precioMaxRequisito === '' || data.precio <= parseFloat(rule.precioMaxRequisito))
            ) {
              const fecha = data.fecha;
              const fechaInicio = data.fechaInicio;
              const fechaFin = data.fechaFin;

              // Creamos objeto en lugar de insert SQL
              const nuevoKpi = {
                nombre: rule.nombre,
                descripcion: rule.descripcion,
                precio: data.precio,
                moneda: rule.moneda,
                iva: rule.iva,
                tipoGasto: rule.tipoGasto,
                fecha,
                fechaInicio,
                fechaFin,
                empresa: rule.empresa,
                categoria: rule.categoria,
                tipoCobroAnual: rule.tipoCobroAnual,
                importancia: rule.importancia,
                idMovimiento: data.id
              };

              kpiPagosArray.push(nuevoKpi);
              data.contabilizado = 1;

              kpiMovimientoArray.push(data);
            }
          }
        }

        if (kpiPagosArray.length == 0) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "No hay movimientos para aplicar las reglas",
              icon: "EditIcon",
              variant: "info",
            },
          });
          return;
        }
        else {

          axios
            .post("/kpi/rules/movimientos", {
              /*pagos: [kpiPagosArray[0]],        
              movimientos: [kpiMovimientoArray[0]]*/
              pagos: kpiPagosArray,
              movimientos: kpiMovimientoArray
            })
            .then(response => {
              return response.data;
            })
            .then(res => {

              if (res.success) {
                this.$toast({
                  component: ToastificationContent,
                  props: {
                    title: "Reglas aplicadas correctamente",
                    icon: "EditIcon",
                    variant: "success",
                  },
                });

                this.loadItems();
              }

            });
        }

      });

     
    },
    guardarDatos(datos) {

      datos.forEach(element => {
        element.descripcion = element.descripcion.replace(/'/g, "");
      });


      axios
        .post("/kpi/banco/array", datos)
        .then(response => {
          return response.data;
        })
        .then(res => {

          if (res.success) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: "Movimientos guardados correctamente",
                icon: "EditIcon",
                variant: "success",
              },
            });

            this.data = [];
            this.selectedBank = null;
            this.csvInput = [];

            this.loadItems();

            //this.loadMovimientos();
          }

        }).catch(err => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Se ha producido un error al guardarlos",
              icon: "EditIcon",
              variant: "danger",
            },
          });
        });


    },
    contabilizadoUpdate(item, estado) {
      item.contabilizado = estado;
      axios
        .put("/kpi/banco", item)
        .then(response => {
          return response.data;
        })
        .then(res => {

        });

    },
    guardarInputGuille() {

      axios
        .post("/kpi/inputGuille", { texto: this.inputGuille })
        .then(response => {
          return response.data;
        })
        .then(res => {
          this.lastInputGuille = this.inputGuille;
          this.inputGuille = "";
        });

    },
    async obtenerDatosRevolut() {
      this.loadingRevolut = true;
      try {
        const response = await axios.get("/kpi/revolut");
        const revolutData = response.data;

        //console.log(revolutData);

        this.loadMovimientos();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Movimientos guardados correctamente de revolut",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error al obtener los datos de Revolut",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loadingRevolut = false;
      }
    },
    async obtenerDatosPaypal() {
      this.loadingPaypal = true;
      try {
        const response = await axios.get("/kpi/paypal");
        const revolutData = response.data;

        //console.log(revolutData);

        this.loadMovimientos();

        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Movimientos guardados correctamente de Paypal",
            icon: "CheckIcon",
            variant: "success",
          },
        });
      } catch (error) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: "Error al obtener los datos de Paypal",
            icon: "AlertTriangleIcon",
            variant: "danger",
          },
        });
      } finally {
        this.loadingPaypal = false;
      }

    },
    crearGastoDesdeMovimiento(item) {
      this.movimientoSeleccionado = item;

      this.descripcion = item.descripcion;
      this.precio = item.precio;

      this.empresaSeleccionada = this.empresas.find((data) => data.text === item.empresa);

      //this.fecha = item.fecha.split('-')[2]+'-'+item.fecha.split('-')[1]+'-'+item.fecha.split('-')[0];

      this.fecha = item.fecha.split('-')[0] + '-' + item.fecha.split('-')[1] + '-' + item.fecha.split('-')[2];
      if (item.divisa == 'GBP')
        this.monedaSeleccionada = this.monedas[2];
      if (item.divisa == 'EUR')
        this.monedaSeleccionada = this.monedas[0];


      //console.log(this.fecha);

      if (item.banco == "Sabadell Envios") {
        this.categoriaSeleccionada = this.categorias[2];
        this.importanciaSeleccionada = this.importanciaOpciones[0];
        this.tipoGasto = "envios";
        document.getElementById('next-button').click();
      }

      this.activeTab = 0;
      window.scrollTo(0, 0);

    },
    guardarFiltro(){

      let datos = {
        filtroTexto: this.filtroTexto,
        filtroTipo: this.filtroTipo,
        filtroEmpresa: this.filtroEmpresa,
        filtroCategorias: this.filtroCategorias,
        filtroImportancia: this.filtroImportancia,
        activeTab: this.activeTab,
        filtroTextoMovimiento: this.filtroTextoMovimiento,
        filtroFinalizadoMovimiento: this.filtroFinalizadoMovimiento,
        filtroBancoMovimiento: this.filtroBancoMovimiento,
        filtroEmpresaMovimiento: this.filtroEmpresaMovimiento,
      }

      const date = new Date();
      let hours = 12;
      date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
      const expires = "expires=" + date.toUTCString();
      document.cookie = 'gastos' + "=" + JSON.stringify(datos) + ";" + expires + ";path=/";

    },
    cargarFiltro(){

      let datos = null;

      const nameEQ = 'gastos' + "=";
      const cookiesArray = document.cookie.split(';');
      for(let i = 0; i < cookiesArray.length; i++) {
          let cookie = cookiesArray[i];
          while (cookie.charAt(0) == ' ') cookie = cookie.substring(1, cookie.length);
          if (cookie.indexOf(nameEQ) == 0) {
            datos =  JSON.parse(cookie.substring(nameEQ.length, cookie.length));
          }
      }

      if(datos != null)
      {
        this.filtroTexto = datos.filtroTexto;
        this.filtroTipo = datos.filtroTipo;
        this.filtroEmpresa = datos.filtroEmpresa;
        this.filtroCategorias = datos.filtroCategorias;
        this.filtroImportancia = datos.filtroImportancia;
        this.activeTab = datos.activeTab;
        this.filtroTextoMovimiento = datos.filtroTextoMovimiento || '';
        this.filtroFinalizadoMovimiento = datos.filtroFinalizadoMovimiento || '';
        this.filtroBancoMovimiento = datos.filtroBancoMovimiento || '';
        this.filtroEmpresaMovimiento = datos.filtroEmpresaMovimiento || '';
      }

    },
  },
  mounted() {
    this.cargarFiltro();
    this.loadItems();    
  },
  watch: {
    filtroTexto() {
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroTipo() {
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroEmpresa() {
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroCategorias() {
      this.buscarFiltro();
      this.guardarFiltro();
    },
    filtroImportancia() {
      this.buscarFiltro();
      this.guardarFiltro();
    },
    activeTab(){
      if(!this.cargandoPrimeraVez)        
        this.guardarFiltro();
    },
    filtroTextoMovimiento(){
      this.guardarFiltro();
    },
    filtroFinalizadoMovimiento(){
      this.guardarFiltro();
    },
    filtroBancoMovimiento(){
      this.guardarFiltro();
    },
    filtroEmpresaMovimiento(){
      this.guardarFiltro();
    },
    /*fecha(){
      console.log(this.fecha);
    }*/
  }
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";

.card-click {
  cursor: pointer;
}

.finish-button {
  background-color: #3bab76 !important;
  border-color: #3bab76 !important;
  color: white !important;
}

.btn-delete {
  color: #ee8080;
}

.btn-delete:hover {
  cursor: pointer;
}

.btn-edit-pago:hover {
  cursor: pointer;
}

.btn-edit-pago {
  color: green;
}

.table-pagos td {
  color: black;
}

.btn-no-contabilizado {
  color: red;
}

.btn-no-contabilizado:hover {
  cursor: pointer;
}

.btn-contabilizado {
  color: green;
}

.btn-contabilizado:hover {
  cursor: pointer;
}

.modal-movimientos {
  min-height: 800px;
}

.gasto-puntual {
  background-color: #c3efd7 !important;
  color: #155724 !important;
  border: 4px solid #c3efd7;
}

.gasto-anual {
  background-color: #d8d4fb !important;
  color: #004085 !important;
  border: 4px solid #d8d4fb;
}

.gasto-impuestos {
  background-color: #f9cfcf !important;
  color: #721c24 !important;
  border: 4px solid #f9cfcf;
}

.gasto-mensual {
  background-color: #ffe4ca !important;
  color: #856404 !important;
  border: 4px solid #ffe4ca;
}

.gasto-nomina {
  background-color: #ffccff !important;
  color: #660066 !important;
  border: 4px solid #ffccff;
}

.gasto-ads {
  background-color: #b8f2f9 !important;
  color: #0c5460 !important;
  border: 4px solid #b8f2f9;
}

.gasto-envios {
  background-color: #e4edac !important;
  color: #1b1e21 !important;
  border: 4px solid #e4edac;
}

.gasto-finalizado {
  background-color: #dcdddf !important;
  color: #155724 !important;
}

.border-puntual {
  border: 4px solid #08bc59;
}

.border-anual {
  border: 4px solid #877afd;
}

.border-impuestos {
  border: 4px solid #f57f7f;
}

.border-mensual {
  border: 4px solid #ffa653;
}

.border-nomina {
  border: 4px solid #fc6bfc;
}

.border-ads {
  border: 4px solid #03b5c8;
}

.border-envios {
  border: 4px solid #93a900;
}

.radio-puntual .custom-control-input:checked~.custom-control-label::before {
  border-color: #08bc59;
  background-color: #08bc59;
}

.radio-anual .custom-control-input:checked~.custom-control-label::before {
  border-color: #877afd;
  background-color: #877afd;
}

.radio-impuestos .custom-control-input:checked~.custom-control-label::before {
  border-color: #f57f7f;
  background-color: #f57f7f;
}

.radio-mensual .custom-control-input:checked~.custom-control-label::before {
  border-color: #ffa653;
  background-color: #ffa653;
}

.radio-nomina .custom-control-input:checked~.custom-control-label::before {
  border-color: #fc6bfc;
  background-color: #fc6bfc;
}

.radio-ads .custom-control-input:checked~.custom-control-label::before {
  border-color: #03b5c8;
  background-color: #03b5c8;
}

.radio-envios .custom-control-input:checked~.custom-control-label::before {
  border-color: #93a900;
  background-color: #93a900;
}


.circle-indicator {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  margin-left: 8px;
  vertical-align: middle;

  position: absolute;
  top: 25px;
  right: 30px;
}

.wizard-harber{
  box-shadow: none;
  border: 1px solid lightgray
}

/* Hide default b-tabs nav since we use custom tabs */
.kpg__tabs-hidden > .nav-tabs,
.kpg__tabs-hidden > .nav,
.kpg__tabs-hidden > ul,
.kpg__tabs-hidden > .tabs > .nav-tabs,
.kpg__tabs-hidden > .tabs > .nav {
  display: none !important;
  border: none !important;
  height: 0 !important;
  overflow: hidden !important;
  margin: 0 !important;
  padding: 0 !important;
}
.kpg__tabs-hidden .nav-tabs {
  display: none !important;
}
.kpg__tabs-hidden > .card-header,
.kpg__tabs-hidden > .tabs > .card-header {
  display: none !important;
}

/* ═══ KPG Tabla global styles ═══ */
.kpg__table {
  margin-bottom: 0;

  thead th {
    background: #f8f9fb !important;
    border-bottom: 2px solid #e9ecf1 !important;
    border-top: none !important;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    color: #8a8e99;
    padding: 12px 14px;
    white-space: nowrap;
  }

  tbody td {
    padding: 10px 14px;
    vertical-align: middle;
    border-bottom: 1px solid #f0f1f4 !important;
    border-top: none !important;
    font-size: 13px;
    color: #5e5873;
    white-space: nowrap;
  }

  tbody tr {
    transition: background 0.15s;
    background: transparent !important;

    &:hover {
      background: #f9f8ff !important;
    }
  }
}

.dark-layout {
  .kpg__tabs-bar {
    background: #1f1f1f !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .kpg__tab {
    color: #b4b7bd !important;

    &:hover {
      background: #242424 !important;
      color: #d0d2d6 !important;
    }
  }

  .kpg__tab--active,
  .kpg__tab--active:hover,
  .kpg__tab--active:focus,
  .kpg__tab--active:active {
    color: #fff !important;
  }

  .kpg__section-title {
    color: #d0d2d6 !important;
  }

  .kpg__list-section {
    background: #1f1f1f !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .kpg__filter-label {
    color: #b4b7bd !important;
  }

  .kpg__table-card {
    border-color: #2c2c2c !important;
  }

  .kpg__table {
    thead th {
      background: #242424 !important;
      border-bottom-color: #2c2c2c !important;
      color: #b4b7bd !important;
    }

    tbody td {
      color: #d0d2d6 !important;
      border-bottom-color: #2c2c2c !important;
    }

    tbody tr:hover {
      background: #242424 !important;
    }
  }

  .kpg__btn-icon,
  .kpg__btn-icon-sm {
    background: #1f1f1f !important;
    border-color: #2c2c2c !important;
    color: #b4b7bd !important;
  }

  .kpg__mov-card {
    background: #1f1f1f !important;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2) !important;
  }

  .kpg__action--edit { background: #1e3a2a !important; }
  .kpg__action--delete { background: #3a1e1e !important; }
  // Mantener el hover de color (el !important de arriba lo anulaba)
  .kpg__action--edit:hover { background: #28c76f !important; }
  .kpg__action--delete:hover { background: #ea5455 !important; }
  .kpg__btn-icon:hover,
  .kpg__btn-icon-sm:hover { background: #7367f0 !important; border-color: #7367f0 !important; color: #fff !important; }

  .kpg {
    // Tarjetas de tipo de gasto: superficie oscura con borde/tinte del color de acento
    @each $tipo, $color in (puntual: #08bc59, anual: #877afd, impuestos: #f57f7f, mensual: #ffa653, nomina: #fc6bfc, ads: #03b5c8, envios: #93a900) {
      .card-click.gasto-#{$tipo} {
        background-color: #1f1f1f !important;
        color: #d0d2d6 !important;
        border-color: rgba($color, 0.3);

        .card-title { color: #e4e6eb !important; }

        &.border-#{$tipo} {
          background-color: rgba($color, 0.08) !important;
          border-color: $color;
        }
      }

      .circle-indicator.gasto-#{$tipo} {
        background-color: $color !important;
        border-color: transparent !important;
      }
    }

    .wizard-harber { border-color: #2c2c2c; }

    // Doble clase para ganar al bloque scoped
    .kpg__section-icon.kpg__section-icon--primary { background: rgba(115, 103, 240, 0.15); }
    .kpg__section-icon.kpg__section-icon--success { background: rgba(40, 199, 111, 0.15); }
    .kpg__section-icon.kpg__section-icon--info    { background: rgba(0, 207, 232, 0.15); }
    .kpg__section-icon.kpg__section-icon--warning { background: rgba(255, 159, 67, 0.15); }
    .kpg__section-subtitle { color: #8e9099; }

    // Movimientos sin tipo (variant secondary)
    .kpg__table tbody tr.table-secondary > td { background-color: #242424 !important; }
  }

}
</style>

<style scoped>
/* ═══ Layout ═══ */
.kpg { display: flex; flex-direction: column; gap: 14px; }

/* ═══ Tabs ═══ */
.kpg__tabs-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 14px;
  padding: 6px 14px 6px 6px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.kpg__tabs {
  display: flex;
  gap: 6px;
}

.kpg__tab {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 10px 24px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, box-shadow 0.2s;
  background: transparent;
  color: #8a8e99;
}
.kpg__tab:hover { background: #f8f9fb; color: #5e5873; }
.kpg__tab:focus, .kpg__tab:active { outline: none; }
.kpg__tab--active {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}
.kpg__tab--active:hover, .kpg__tab--active:focus, .kpg__tab--active:active { background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%); color: #fff; }

/* ═══ Section headers ═══ */
.kpg__section-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.kpg__section-icon {
  width: 34px;
  height: 34px;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  flex-shrink: 0;
}
.kpg__section-icon--primary { background: #eeedfd; color: #7367f0; }
.kpg__section-icon--success { background: #e8fce8; color: #28c76f; }
.kpg__section-icon--info    { background: #e0f4ff; color: #00cfe8; }
.kpg__section-icon--warning { background: #fff3e0; color: #ff9f43; }

.kpg__section-title { font-size: 15px; font-weight: 600; color: #3b4253; }
.kpg__section-subtitle { font-size: 14px; color: #8a8e99; }

/* ═══ List section ═══ */
.kpg__list-section {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  gap: 14px;
}

/* ═══ Filters ═══ */
.kpg__filters {
  display: flex;
  align-items: flex-end;
  gap: 12px;
  flex-wrap: wrap;
  margin-bottom: 10px;
}

.kpg__filter-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 130px;
}

.kpg__filter-item--wide { flex: 1.5; min-width: 180px; }

.kpg__filter-label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #8a8e99;
  margin-bottom: 0;
}

/* ═══ Tabla card ═══ */
.kpg__table-card {
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #f0f1f4;
}

.kpg__tabla-scroll {
  width: 100%;
  overflow-x: auto;
}

/* ═══ Acciones tabla ═══ */
.kpg__actions { display: flex; align-items: center; gap: 4px; }

.kpg__action {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 13px;
}

.kpg__action--edit { color: #28c76f; background: #e8fce8; }
.kpg__action--edit:hover { background: #28c76f; color: #fff; }
.kpg__action--delete { color: #ea5455; background: #fce4e4; }
.kpg__action--delete:hover { background: #ea5455; color: #fff; }

/* ═══ Pagado / Contabilizado ═══ */
.kpg__pagado {
  cursor: pointer;
  font-size: 15px;
  font-weight: 600;
}
.kpg__pagado--no { color: #ea5455; }
.kpg__pagado--si { color: #28c76f; }

/* ═══ Botones ═══ */
.kpg__btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  border-radius: 10px;
  border: none;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

.kpg__btn--primary {
  background: linear-gradient(135deg, #7367f0 0%, #9b8cf8 100%);
  color: #fff;
  box-shadow: 0 4px 14px rgba(115, 103, 240, 0.35);
}
.kpg__btn--primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(115, 103, 240, 0.45);
}

.kpg__btn--outline {
  background: transparent;
  color: #7367f0;
  border: 1px solid #7367f0;
}
.kpg__btn--outline:hover { background: #7367f0; color: #fff; }

.kpg__btn--sm { padding: 5px 12px; font-size: 12px; }

.kpg__btn-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid #dfe3e8;
  background: #fff;
  color: #6e6b7b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  transition: all 0.2s;
  margin-left: auto;
}
.kpg__btn-icon:hover { background: #7367f0; color: #fff; border-color: #7367f0; }

.kpg__btn-icon-sm {
  width: 28px;
  height: 28px;
  border-radius: 7px;
  border: 1px solid #dfe3e8;
  background: #fff;
  color: #6e6b7b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  transition: all 0.2s;
}
.kpg__btn-icon-sm:hover { background: #7367f0; color: #fff; border-color: #7367f0; }

/* ═══ Movimientos ═══ */
.kpg__movimientos {
  display: flex;
  flex-direction: column;
  gap: 14px;
  min-height: 600px;
}

.kpg__mov-card {
  background: #fff;
  border-radius: 14px;
  padding: 20px 24px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
}

.kpg__mov-inline {
  display: flex;
  align-items: center;
  gap: 12px;
}

.kpg__mov-upload {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.kpg__mov-api-buttons {
  display: flex;
  gap: 8px;
}
</style>
